import request from '@/utils/request'
import config from '@/utils/config'

/** 通用上传（需登录），返回 AjaxResult：{ code, url, ... } */
export const uploadCommonFile = (filePath) =>
  new Promise((resolve, reject) => {
    uni.uploadFile({
      url: `${config.baseURL}/common/upload`,
      filePath,
      name: 'file',
      header: {
        Authorization: `Bearer ${uni.getStorageSync('token') || ''}`,
      },
      success: (res) => {
        try {
          const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
          if (Number(data.code) === 200 && data.url) {
            resolve(data)
          } else if (Number(data.code) === 401) {
            uni.removeStorageSync('token')
            reject(new Error(data.msg || '未登录'))
          } else {
            reject(new Error(data.msg || '上传失败'))
          }
        } catch (e) {
          reject(e)
        }
      },
      fail: reject,
    })
  })

// Auth
export const login = (data) => request({ url: '/api/h5/auth/login', method: 'POST', data })
export const register = (data) => request({ url: '/api/h5/auth/register', method: 'POST', data })
/** 微信小程序授权登录 */
export const wechatLogin = (data) => request({ url: '/api/h5/auth/wechat-login', method: 'POST', data })
export const getCaptcha = () => request({ url: '/api/h5/auth/captcha', method: 'GET' })
/** 注册页发送短信验证码（匿名），非图形验证码 */
export const sendRegisterSms = (phone) =>
  request({ url: '/api/h5/auth/send-register-sms', method: 'POST', data: { phone } })

// Home
export const getHomeData = () => request({ url: '/api/h5/home/full', method: 'GET' })
/** 功能开关：充值/提现等（审核期可关闭） */
export const getFeatureFlags = () => request({ url: '/api/h5/config/features', method: 'GET' })
export const getBanners = () => request({ url: '/api/h5/home/banners', method: 'GET' })
export const getFeaturedPack = () => request({ url: '/api/h5/home/featured-pack', method: 'GET' })
export const getCardPacks = () => request({ url: '/api/h5/home/card-packs', method: 'GET' })

// Card Pack
export const getCardPackList = (params) => request({ url: '/api/h5/card-pack/list', method: 'GET', data: params })
export const getCardPackDetail = (packId) => request({ url: `/api/h5/card-pack/${packId}`, method: 'GET' })
export const buyCardPack = (packId, data) => request({ url: `/api/h5/card-pack/${packId}/buy`, method: 'POST', data })
/** 创建待支付卡包订单，返回 payUrl 供跳转第三方支付 */
export const createCardPackPayOrder = (packId, data) => request({ url: `/api/h5/card-pack/${packId}/pay-order`, method: 'POST', data })
/** 模拟支付完成实体套装订单（无第三方支付时使用） */
/** 余额支付卡包订单（与汇付支付二选一） */
export const payPackOrderByBalance = (orderNo) => request({ url: `/api/h5/card-pack/pay-balance/${orderNo}`, method: 'POST' })

// Draw
export const getDrawActivities = (params) => request({ url: '/api/h5/draw/activities', method: 'GET', data: params })
export const getDrawActivityDetail = (activityId) => request({ url: `/api/h5/draw/activity/${activityId}`, method: 'GET' })
export const reserveDraw = (activityId) => request({ url: `/api/h5/draw/activity/${activityId}/reserve`, method: 'POST' })
export const getMyDrawCodes = (activityId) => request({ url: `/api/h5/draw/my-codes/${activityId}`, method: 'GET' })
export const purchaseDrawCode = (codeId) => request({ url: `/api/h5/draw/code/${codeId}/purchase`, method: 'POST' })

// Scratch
export const getScratchActivities = (params) => request({ url: '/api/h5/scratch/activities', method: 'GET', data: params })
export const getScratchActivityDetail = (activityId) => request({ url: `/api/h5/scratch/activities/${activityId}`, method: 'GET' })
export const getMyScratchChances = () => request({ url: '/api/h5/scratch/my-chances', method: 'GET' })
export const doScratch = (activityId) => request({ url: `/api/h5/scratch/${activityId}/scratch`, method: 'POST' })
export const getMyScratchRecords = (params) => request({ url: '/api/h5/scratch/my-records', method: 'GET', data: params })

// Compose
export const getComposeFormulas = (params) => request({ url: '/api/h5/compose/formulas', method: 'GET', data: params })
export const getComposeFormulaDetail = (formulaId) => request({ url: `/api/h5/compose/formula/${formulaId}`, method: 'GET' })
export const executeCompose = (userCardIds) => request({ url: '/api/h5/compose/execute', method: 'POST', data: { userCardIds } })
export const executeComposeByFormula = (formulaId, userCardIds) => request({ url: `/api/h5/compose/formula/${formulaId}/execute`, method: 'POST', data: { userCardIds } })
export const getMyPresets = () => request({ url: '/api/h5/compose/my-presets', method: 'GET' })
export const savePreset = (data) => request({ url: '/api/h5/compose/preset', method: 'POST', data })
export const deletePreset = (presetId) => request({ url: `/api/h5/compose/preset/${presetId}`, method: 'DELETE' })

// Decompose
export const getDecomposeRules = (params) => request({ url: '/api/h5/decompose/rules', method: 'GET', data: params })
export const executeDecompose = (userCardId, ruleId) => request({ url: '/api/h5/decompose/execute', method: 'POST', data: { userCardId, ruleId } })

// Market
export const getMarketListings = (params) => request({ url: '/api/h5/market/listings', method: 'GET', data: params })
export const getMarketCards = (params) => request({ url: '/api/h5/market/cards', method: 'GET', data: params })
export const getMarketCardDetail = (cardId) => request({ url: `/api/h5/market/card/${cardId}/detail`, method: 'GET' })
export const getMarketListingDetail = (listingId) => request({ url: `/api/h5/market/listing/${listingId}`, method: 'GET' })
export const getCardKline = (cardId, days = 7) => request({ url: `/api/h5/market/card/${cardId}/kline`, method: 'GET', data: { days } })
export const createListing = (userCardId, price) => request({ url: '/api/h5/market/listing', method: 'POST', data: { userCardId, price } })
export const adjustListingPrice = (listingId, price) => request({ url: `/api/h5/market/listing/${listingId}/price`, method: 'PUT', data: { price } })
export const toggleListing = (listingId, isOnShelf) => request({ url: `/api/h5/market/listing/${listingId}/toggle`, method: 'PUT', data: { isOnShelf } })
export const cancelListing = (listingId) => request({ url: `/api/h5/market/listing/${listingId}`, method: 'DELETE' })
export const buyListing = (listingId) => request({ url: `/api/h5/market/listing/${listingId}/buy`, method: 'POST' })
export const createMarketPayOrder = (listingIds) =>
  request({ url: '/api/h5/market/pay-order', method: 'POST', data: { listingIds } })
export const mockPayMarketOrder = (orderNo) =>
  request({ url: `/api/h5/market/mock-pay/${orderNo}`, method: 'POST' })
/** 余额支付市集订单（与汇付支付二选一） */
export const payMarketOrderByBalance = (orderNo) =>
  request({ url: `/api/h5/market/pay-balance/${orderNo}`, method: 'POST' })
export const createAutoBuy = (cardId, maxPrice, quantity = 1) =>
  request({ url: '/api/h5/market/auto-buy', method: 'POST', data: { cardId, maxPrice, quantity } })
export const getMyAutoBuys = (params) => request({ url: '/api/h5/market/my-auto-buys', method: 'GET', data: params })
export const getPurchaseIntents = (cardId) => request({ url: `/api/h5/market/card/${cardId}/purchase-intents`, method: 'GET' })
export const cancelAutoBuy = (autoBuyId) => request({ url: `/api/h5/market/auto-buy/${autoBuyId}`, method: 'DELETE' })
export const getMyListings = (params) => request({ url: '/api/h5/market/my-listings', method: 'GET', data: params })
export const getLuckyDropToday = () => request({ url: '/api/h5/market/lucky-drop/today', method: 'GET' })
export const getUnreadLuckyDrops = () => request({ url: '/api/h5/market/lucky-drop/unread', method: 'GET' })
export const ackLuckyDropRecords = (recordIds) =>
  request({ url: '/api/h5/market/lucky-drop/ack', method: 'POST', data: { recordIds } })
export const getMarketConfig = () => request({ url: '/api/h5/market/config', method: 'GET' })
export const getCardMarketLowestPrice = (cardId) => request({ url: `/api/h5/market/card/${cardId}/lowest-price`, method: 'GET' })

// Store
export const getStoreProducts = (params) => request({ url: '/api/h5/store/products', method: 'GET', data: params })
export const getStoreProductDetail = (productId) => request({ url: `/api/h5/store/product/${productId}`, method: 'GET' })
export const getStoreCategories = () => request({ url: '/api/h5/store/categories', method: 'GET' })
export const getStoreProductsByCard = (cardId) => request({ url: `/api/h5/store/products/by-card/${cardId}`, method: 'GET' })
export const exchangeProduct = (productId, data) => request({ url: `/api/h5/store/product/${productId}/exchange`, method: 'POST', data })

// Warehouse
export const getWarehouseCards = (params) => request({ url: '/api/h5/warehouse/cards', method: 'GET', data: params })
export const getWarehouseCardDetail = (userCardId) => request({ url: `/api/h5/warehouse/card/${userCardId}`, method: 'GET' })
export const getWarehouseStats = () => request({ url: '/api/h5/warehouse/stats', method: 'GET' })

// User
export const getUserProfile = () => request({ url: '/api/h5/user/profile', method: 'GET' })
export const updateUserProfile = (data) => request({ url: '/api/h5/user/profile', method: 'PUT', data })
export const recharge = (amount, payMethod = 'huifu') => request({ url: '/api/h5/user/recharge', method: 'POST', data: { amount, payMethod } })
export const getHuifuWalletStatus = () => request({ url: '/api/h5/pay/huifu/wallet', method: 'GET' })
export const openHuifuWallet = (data) => request({ url: '/api/h5/pay/huifu/wallet/open', method: 'POST', data })
export const syncHuifuOrder = (orderNo) => request({ url: `/api/h5/pay/huifu/order/${orderNo}/sync`, method: 'POST' })
export const createHuifuOrderPayment = (orderNo) => request({ url: `/api/h5/pay/huifu/order/${orderNo}`, method: 'POST' })
/** 汇付钱包管理页（用户自助绑卡/提现），返回 redirectUrl */
export const getHuifuWalletManageUrl = () => request({ url: '/api/h5/pay/huifu/wallet/manage', method: 'GET' })
export const getBalanceLog = (params) => request({ url: '/api/h5/user/balance-log', method: 'GET', data: params })
export const getPointsLog = (params) => request({ url: '/api/h5/user/points-log', method: 'GET', data: params })
export const sendSmsCode = (phone) => request({ url: '/api/h5/user/send-sms', method: 'POST', data: { phone } })
export const bindPhone = (phone, code) => request({ url: '/api/h5/user/bind-phone', method: 'POST', data: { phone, code } })
export const deleteAccount = () => request({ url: '/api/h5/user/delete-account', method: 'POST' })

// Address
export const getAddressList = () => request({ url: '/api/h5/address/list', method: 'GET' })
export const getAddressDetail = (addressId) => request({ url: `/api/h5/address/${addressId}`, method: 'GET' })
export const addAddress = (data) => request({ url: '/api/h5/address', method: 'POST', data })
export const editAddress = (data) => request({ url: '/api/h5/address', method: 'PUT', data })
export const deleteAddress = (addressId) => request({ url: `/api/h5/address/${addressId}`, method: 'DELETE' })

// Order
export const getOrderList = (params) => request({ url: '/api/h5/order/list', method: 'GET', data: params })
export const getOrderDetail = (orderId) => request({ url: `/api/h5/order/${orderId}`, method: 'GET' })
export const cancelOrder = (orderId) => request({ url: `/api/h5/order/${orderId}/cancel`, method: 'POST' })
export const confirmReceiveOrder = (orderId) => request({ url: `/api/h5/order/${orderId}/confirm-receive`, method: 'POST' })

// Withdraw
export const getWithdrawList = (params) => request({ url: '/api/h5/withdraw/list', method: 'GET', data: params })
export const applyWithdraw = (data) => request({ url: '/api/h5/withdraw/apply', method: 'POST', data })

// CDK
export const redeemCdk = (cdkCode) => request({ url: '/api/h5/cdk/redeem', method: 'POST', data: { cdkCode } })

// Announcement
export const getAnnouncementList = () => request({ url: '/api/h5/announcement/list', method: 'GET' })
export const getAnnouncementDetail = (id) => request({ url: `/api/h5/announcement/${id}`, method: 'GET' })
